/**
 *
 * @param {*} response
 */
export const handleResponse = (response, version = '12.0.0') => {
    //Here we check if the version has changed whilst the user has the application open;
    if (
        response.headers &&
        response.headers['X-Tradera-Version'] &&
        response.headers['X-Tradera-Version'] !== version
    ) {
        window.location.reload(true);
    }
    return {
        data: response.data,
        status: response.status
    };
};
/**
 *
 * @param {*} error
 */
export const getErrorStatus = error => {
    if (error.toString().includes('timeout')) {
        return 408;
    }
    if (error.toString().includes('Network')) {
        return 500;
    }
};

/**
 *
 * @param {*} error
 */
export const handleError = error => ({
    response: error.response ? error.response : [],
    message: error.message ? error.message : error.toString(),
    status:
        error.response && error.response.status
            ? error.response.status
            : getErrorStatus(error)
});



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/axios.js